// Mobile drawer state — toggles `.is-open` on .primary-nav + backdrop and
// `body.nav-open` (scroll lock). Markup lives in index.php; this script
// only wires up the handlers.
//
// Uses Joomla-provided global jQuery.

(function ($) {
  if (!$) return;

  $(function () {
    var $nav = $('#primary-nav');
    if (!$nav.length) return;

    var $backdrop = $('.primary-nav-backdrop');
    var $body = $('body');
    var $toggle = $('.menu-toggle');

    function open() {
      $nav.addClass('is-open');
      $backdrop.addClass('is-open');
      $body.addClass('nav-open');
      $toggle.attr('aria-expanded', 'true');
    }

    function close() {
      $nav.removeClass('is-open');
      $backdrop.removeClass('is-open');
      $body.removeClass('nav-open');
      $toggle.attr('aria-expanded', 'false');
    }

    $(document).on('click', '.menu-toggle', open);
    $(document).on('click', '.primary-nav__close', close);
    $backdrop.on('click', close);

    // Close when a leaf link inside the drawer is clicked. Skip the
    // dropdown-toggle (which only opens the submenu, doesn't navigate)
    // and skip clicks while at desktop width — easier to test via media
    // query than viewport math.
    $nav.on('click', 'a.nav-link', function (e) {
      var $a = $(this);
      if ($a.hasClass('dropdown-toggle')) return;
      if (window.matchMedia('(min-width: 981px)').matches) return;
      close();
    });

    $(document).on('keydown', function (e) {
      if (e.key === 'Escape' && $nav.hasClass('is-open')) close();
    });
  });
})(window.jQuery);
